import { ReactComponent as AwladLogo } from 'assets/v3/awlad-school-logo.svg'
import { AmplifyLoadingSpinner } from '@aws-amplify/ui-react'
import { Player } from '@lottiefiles/react-lottie-player'
import checkmarkAnimation from 'assets/animations/checkmark.json'
import { useState } from 'react'
import { useActivateCode } from 'operations/premium/useActivateCode'
import '../css/ActivationCodePage.scss'

const ERROR_MESSAGES: Record<string, string> = {
  InvalidActivationCode: "Code d'activation invalide.",
  CodeAlreadyUsed: 'Ce code a déjà été utilisé.',
  CodeExpired: 'Ce code a expiré.',
  UserNotFound: "Aucun compte Awlad School trouvé avec cet email. Veuillez d'abord créer un compte sur l'application.",
  ServerError: 'Une erreur est survenue. Veuillez réessayer.',
  UnknownError: 'Une erreur est survenue. Veuillez réessayer.',
}

export const ActivationCodePage = () => {
  const [code, setCode] = useState('')
  const [email, setEmail] = useState('')

  const { activateCode, isLoading, error, isSuccess } = useActivateCode()

  const canSubmit = code.trim().length > 0 && email.trim().length > 0 && !isLoading && !isSuccess

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!canSubmit) return
    activateCode({ code: code.trim(), email: email.trim() })
  }

  return (
    <div className="ks-activation-page">
      <div className="ks-activation-card">
        <AwladLogo className="ks-awlad-logo" />

        {isSuccess ? (
          <div className="ks-activation-success-screen">
            <div className="ks-activation-success-icon">
              <Player src={checkmarkAnimation} autoplay loop style={{ width: 80, height: 80 }} />
            </div>
            <h1>Activation réussie</h1>
            <p>Vous êtes désormais abonné Premium !</p>
            <p className="ks-activation-success-hint">
              Ouvrez l'application <a href="https://applinks.awlad-school.com">Awlad School</a> pour profiter de votre abonnement.
            </p>
          </div>
        ) : (
          <>
            <h1>Activez votre abonnement Premium</h1>
            <form onSubmit={handleSubmit}>
              <div className="ks-activation-field">
                <label>Votre code d'activation</label>
                <input
                  className="ks-activation-input"
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  autoCapitalize="characters"
                  autoCorrect="off"
                  autoComplete="off"
                />
              </div>
              <div className="ks-activation-field">
                <label>Adresse e-mail de votre compte Awlad School</label>
                <input
                  className="ks-activation-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
              <button
                className="ks-activation-btn"
                type="submit"
                disabled={!canSubmit}
              >
                <span style={{ opacity: isLoading ? 0 : 1 }}>Activer</span>
                {isLoading && (
                  <span className="ks-activation-spinner">
                    <AmplifyLoadingSpinner style={{ height: '1em' }} />
                  </span>
                )}
              </button>
            </form>
            {error && (
              <p className="ks-activation-error">
                {ERROR_MESSAGES[error] || ERROR_MESSAGES.UnknownError}
              </p>
            )}
          </>
        )}

      </div>
      <p className="ks-activation-contact">
        En cas de problème, <a href="/contactus">contactez-nous</a>
      </p>

    </div>
  )
}
